import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_LEGACY_DIALOG_DATA, MatLegacyDialogRef } from '@angular/material/legacy-dialog';
import { IssueNameErrors } from '../../../enums/issue-name-errors';
import { MediaType } from '../../../enums/media-type';

@Component({
  selector: 'mee-upload-file-templates',
  templateUrl: './load-pdf-templates.component.html',
  styleUrls: ['./load-pdf-templates.component.scss'],
})
export class LoadPdfTemplatesComponent implements OnInit {
  private formBuilder = inject(FormBuilder);
  private dialogRef = inject(MatLegacyDialogRef<LoadPdfTemplatesComponent>);
  private locatePackage = inject(MAT_LEGACY_DIALOG_DATA);
  readonly mediaType = MediaType;

  templatesForm = this.formBuilder.group({
    CoverPagesUrl: ['', Validators.required],
    MainPageUrl: ['', Validators.required],
    TrailingPagesUrl: ['', Validators.required],
    Bottom: 0,
    Side: 0,
    Top: 0
  });

  ngOnInit(): void {
    this.templatesForm.patchValue(this.locatePackage);
  }

  saveTemplates(): void {
    this.dialogRef.close(this.templatesForm.getRawValue());
  }
}
